<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0041_master_belongs_detail</div>
        <app-header>esma</app-header>
        <div :class="'container ' +pageContainerSize">
          <title-and-slot title="部署・チーム（詳細）" >
          </title-and-slot>
          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-4">
            <button class="btn btn-primary" style="min-width:100px;float: left;margin-left: 5px;" @click="backToList" >＜　戻る</button>
            </div>
          </div>
            <div class="col-xs-5" style="">
              <!-- Coll A -->
              <field-box   v-for="f in formFields.col1"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
              <field-box   v-for="f in formFields.col2"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
            </div>
            <div class="col-xs-7" style="">
              <!-- Coll B -->
            </div>
            <div class="col-xs-7" style="">
              <field-box   v-for="f in formFields.col3"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
              <!-- Coll C -->
            </div>

          </div>
          <div class="col-xs-5" style="">
          <div class="row" style="margin-bottom:10px;">
              <button v-if="read_only == false"  class="btn btn-primary" style="min-width:100px;float: right;margin-right: 10px;px;background: #92D050;border-color:#92D050;"  @click="onSave" >登録</button>
              <button
              :disabled="checkUserPermission(true,permissionMode.EDIT) == false"
              v-if="read_only == true" class="btn btn-primary" style="min-width:100px;float:right;margin-lift: 10px;;" @click="onEdit"  >編集</button>
              <button v-if="read_only == false" :disabled="false" class="btn btn-primary" style="min-width:100px;float:right;margin-right: 10px;background: #A6A6A6;border-color:#A6A6A6;" @click="btnCancel" >キャンセル</button>
              <button
              :disabled="checkUserPermission(true,permissionMode.DELETE) == false"
              v-if="read_only == true" class="btn btn-primary" style="min-width:100px;float:right;margin-right: 10px;background: #FF7C80;border-color:#FF7C80;" @click="onDelete">削除</button>

              <button
                  v-if="read_only == true"
                  :disabled="checkUserPermission(true,permissionMode.EDIT) == false"
                  class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;" @click="cloneRecord" >コピー</button>
          </div>
          </div>
      <confirmation-modal tag="deleteMasterBelongsModal" @done="onConfirmDelete" />
    </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { fields, filed_types } from '@/rules/fields_master_belongs';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:master_belong_details');
import fieldBoxes from '@/components/form-field';
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';
export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'field-box': fieldBoxes,
  },
  data() {
    return {
      api_name:"master_belongs",
      local_seq_id:-1,
      page_acl: acl.master
    };
  },
  computed: {
    localSeqId:{
      get(){
        return this.local_seq_id;
      },
      set(v){
        this.local_seq_id = v;
      }
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    formFields() {
      return {
        col1:[
          utils.extend(fields.department_code, {}),
          utils.extend(fields.company, {}),
          utils.extend(fields.department, {}),
        ],
        col2:[
          utils.extend(fields.team, {}),
          utils.extend(fields.team_code, {}),
        ],
        col3:[
        ],
      }
    },
    loadBy(){
      return this.$route.meta.load_by;
    }
  },
  methods: {
    cloneRecord(){
      return this.$router.push({ name: "page_0060_redirect", params: {
        url:"/master_belongs/clone/" + this.localSeqId,
        message:"コピー ...",
        wait:50
      } });
    },
    onSave(){
      // this.read_only = false;
      // this.commonSaveInfo(this,this.api_name, {} );
      var field_name_arr = ["department_code","company","department","team","team_code"];
      this.commonSaveIfNotBlank(this,this.api_name, {} ,field_name_arr,(err,data)=>{
        if(err == null){
          return this.$router.push({ name: "page_0060_redirect", params: {
            url:"/master_belongs/" + data.seq_id,
            message:"登録 ...",
            wait:50
          }});
        }
      });
    },
    onEdit(){
      mdebug("onEdit")
      this.commonOnEdit();
    },
    btnCancel() {
      this.cancelCurrentSelection(true);
    },
    onDelete(){
      bus.$emit("deleteMasterBelongsModal",{
        title: "削除",
        message: "部署・チームの削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color:"danger",
        no_color:"info",
        model_height:"50"
      });
    },
    onConfirmDelete(mode){
      if(mode == "yes"){
        this.commonDelete(this);
      }
    },
    backToList(){
      return this.$router.push({ name: "page_0041_master_belongs", params: {} });
    }
  },
  mounted() {
    if(this.loadBy == "clone"){
      this.localSeqId = Number.MAX_SAFE_INTEGER
      this.commonLoadRecord({},(err,result)=>{
        // this.commonEditDeleteCmdHandler(this);
        setTimeout(() => {
          this.$store.state[this.stateIsEditingNew] = true;
          this.read_only = false;
          this.is_new = true;

          Object.keys(result.data).forEach(k =>{
            var value = result.data[k];
            if(k == "seq_id"){
              this.$store.state[this.stateCurrentRow][k] = Number.MAX_SAFE_INTEGER;
            }else if(k == "team" || k == "team_code" ){
              this.$store.state[this.stateCurrentRow][k] = "";
              this.$store.state[this.stateCurrentEditing][k] = "";
            }else{
              this.$store.state[this.stateCurrentRow][k] = value;
              this.$store.state[this.stateCurrentEditing][k] = value;
            }
          })
        }, 300);
      })
    }else{
      this.localSeqId = this.$route.params.seq_id;
      this.commonLoadRecord({},(err,result)=>{
        
        this.commonEditDeleteCmdHandler(this);
      })
    }
  },
  beforeDestroy() {
  },
  beforeMount() {
  }
};

</script>
<style scoped>

input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// page_0041_master_belongs_detail.vue?3750eeb8